import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { generateRandomString } from '../../utils/Helper'

const QRCodeGenerator = ({ size = 50, downloadScale = 5, id }) => {

  const handleDownload = () => {
    const svgElement = document.getElementById(`qrcode-${id}`);

    const svgData = new XMLSerializer().serializeToString(svgElement);


    const svgBlob = new Blob([svgData], { type: 'image/svg+xml' });


    const url = URL.createObjectURL(svgBlob);


    const img = new Image();
    img.onload = () => {

      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');


      const canvasSize = size * downloadScale;
      canvas.width = canvasSize;
      canvas.height = canvasSize;


      ctx.drawImage(img, 0, 0, img.width * downloadScale, img.height * downloadScale);


      const imageUrl = canvas.toDataURL('image/png');

      const randomString = generateRandomString(5);

      const downloadLink = document.createElement('a');
      downloadLink.href = imageUrl;
      downloadLink.download = `qr-code-${randomString}.png`;
      downloadLink.click();
      URL.revokeObjectURL(url);
    };


    img.src = url;
  };

  const qrUrl = `${window.location.href}/view/${id}`

  return (
    <div className="flex flex-col items-center">
      <QRCodeSVG
        id={`qrcode-${id}`}
        value={qrUrl}
        size={size}
        fgColor="#000000"
        bgColor="#ffffff"
        level="M"
      />
      <button
        onClick={handleDownload}
        className="text-orange-500 underline text-sm mt-1 hover:text-orange-700"
      >
        Download
      </button>
    </div>
  );
};

export default QRCodeGenerator;